import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

export type CurrentNode = {
  node_id?: string | null;
  type: string;
  subtype?: string | null;
};

type CurrentNodeContextProps = {
  node: CurrentNode | null;
  setNode: Dispatch<SetStateAction<CurrentNode | null>>;
};

const CurrentNodeContext = createContext<CurrentNodeContextProps | undefined>(
  undefined,
);

export const CurrentNodeProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [node, setNode] = useState<CurrentNode | null>(null);
  const value = useMemo(() => ({ node, setNode }), [node, setNode]);

  return (
    <CurrentNodeContext.Provider value={value}>
      {children}
    </CurrentNodeContext.Provider>
  );
};

export const useCurrentNode = (): CurrentNodeContextProps => {
  const context = useContext(CurrentNodeContext);
  if (!context) {
    throw new Error("useCurrentNode must be used within a CurrentNodeProvider");
  }
  return context;
};
